const convertTimeToTitle = (date) => date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })

export default convertTimeToTitle
